import { useEffect } from "react"
import { projectStore } from "../store/Store"

export const useGetLoadOptions = (setDD, field, idField, isAsset) => {
  const projectLoads = projectStore(data => data.projectLoads)
  const projectAssetLoads = projectStore(data => data.projectAssetLoads)

  
  useEffect(() => {
    if (projectLoads && field && idField && !isAsset) {
      const check = []
      const options = []
      projectLoads.forEach(d => {
        if (check.indexOf(d[field]) === -1) {
          options.push({value: d[idField], label: d[field]})
          check.push(d[field])
        }
      })
      setDD(options)
    } else if (projectAssetLoads && field && idField && isAsset) {
      const check = []
      const options = []
      projectAssetLoads.forEach(d => {
        if (check.indexOf(d[field]) === -1) {
          options.push({value: d[idField], label: d[field]})
          check.push(d[field])
        }
      })
      setDD(options)
    }
  }, [projectLoads, field, setDD, idField, isAsset, projectAssetLoads])
}